'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import ScopeWrapper from 'AdsUI/components/ScopeWrapper';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import Small from 'UIComponents/elements/Small';
import UIButton from 'UIComponents/button/UIButton';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import PortalIdParser from 'PortalIdParser';
const DEMO_ROUTE = `/ads-demo/${PortalIdParser.get()}/`;

const ConnectAccountsButton = ({
  className
}) => /*#__PURE__*/_jsx(ScopeWrapper, {
  tooltipKey: "connectAccounts",
  children: /*#__PURE__*/_jsx(UIRouterButton, {
    to: "onboarding-wizard",
    use: "primary",
    "data-test-id": "onboarding-connect-accounts",
    className: className,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "onboarding.wizard.connectAccountsPluralLabel"
    })
  })
});

const GoToDemoButton = () => /*#__PURE__*/_jsx(UIButton, {
  use: "secondary",
  onClick: () => {
    usageTracker.track('demoAction', {
      action: 'Started onboarding demo'
    });
    window.location.href = DEMO_ROUTE;
  },
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "zeroState.goToDemo"
  })
});

const EmptyStateActionButtons = ({
  hasAdsWrite,
  className
}) => {
  if (!hasAdsWrite) {
    return /*#__PURE__*/_jsx("p", {
      className: className,
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "zeroState.missingAdsPublish"
        })
      })
    });
  }

  return /*#__PURE__*/_jsxs(UIButtonWrapper, {
    className: className,
    children: [/*#__PURE__*/_jsx(ConnectAccountsButton, {}), /*#__PURE__*/_jsx(GoToDemoButton, {})]
  });
};

export default EmptyStateActionButtons;